// removed by extract-text-webpack-plugin
module.exports = {"root":"_2a7VV2T"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/Search/components/RefineBar/components/RefineRadio/RefineRadio.less
 ** module id = 917
 ** module chunks = 0
 **/